import React, { FC } from 'react';
import CMPImage from 'components/global/image';
interface Props {
  wh?: number;
}
const CarpentryIcon: FC<Props> = ({ wh }) => {
  return (
    <CMPImage
      asset={{
        src: `${process.env.PUBLIC_URL}/images/professions/Carpentry.png`,
        alt: 'Carpentry',
      }}
      width={wh || 64}
      height={wh || 64}
    />
  );
};

export default CarpentryIcon;
